import ReactDOM from 'react-dom/client';
import React from 'react';
import './polyfills/process-global'; // Must be first to polyfill process
import './polyfills/buffer-global'; // Must be second to polyfill Buffer
import './analytics-init'; // Analytics (GTM, Smartlook) initialization
import './index.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from 'config/apolloClient';
import trackUserProperties from './utils/analytics/trackUserProperties';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';

// Check if Sentry is enabled - DSN must be set and DISABLED must not be "true"
const isSentryEnabled =
  import.meta.env.VITE_APP_SENTRY_DSN && import.meta.env.VITE_APP_SENTRY_DISABLED !== 'true';

if (isSentryEnabled) {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: Number(import.meta.env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE) || 0.1,
    environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT || 'development',
    release: import.meta.env.VITE_APP_SENTRY_RELEASE,
    beforeSend(event, _hint) {
      return event;
    },
    debug: import.meta.env.MODE === 'development',
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <App />
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Track user properties for analytics.
trackUserProperties();
